import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

export const setTranslations = (state: State, action: Actions.SetTranslations) =>
  assocPath(['translations'], action.payload.translations, state);
